export default {
    employeeManagement: 'บริหารจัดการพนักงาน',
    importEmployeeList: 'นำเข้าพนักงาน',
    employeeList: 'รายชื่อพนักงาน',
    employeeImage: 'รูปภาพพนักงาน'
}
